import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
  ViewEncapsulation
} from '@angular/core';
import {
  Floor,
  InspectionPressureSystemInStairwellsCompatibilityCheck,
  PressureSystemType
} from '@authority-labs/api-interfaces';
import { Base1001TestResultsComponent } from '../../base-1001-certificate';

interface Table {
  type?: PressureSystemType;
  withSprinklers?: boolean;
  name?: string;
  floorsOrDoors?: Floor[];
}

@Component({
  selector:
    'authority-labs-pressure-system-in-stairwells-compatibility-check-test-results',
  templateUrl:
    './pressure-system-in-stairwells-compatibility-check-test-results.component.html',
  styleUrls: [
    './pressure-system-in-stairwells-compatibility-check-test-results.component.scss'
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.ShadowDom
})
export class PressureSystemInStairwellsCompatibilityCheckTestResultsComponent
  extends Base1001TestResultsComponent
  implements OnInit
{
  @Input() inspection: InspectionPressureSystemInStairwellsCompatibilityCheck;

  tables: Table[] = [];

  ngOnInit(): void {
    this.init(
      this.inspection.cases,
      new InspectionPressureSystemInStairwellsCompatibilityCheck(
        this.inspection
      ).getNotes()
    );

    this.tables = this.inspection.stairsRooms
      ?.map((s) =>
        [
          {
            type: s.type,
            withSprinklers: s.withSprinklers,
            name: s.closedDoorsStairsName,
            floorsOrDoors: s.closedDoorsFloors
          },
          {
            type: s.type,
            withSprinklers: s.withSprinklers,
            name: s.openDoorsStairsName,
            floorsOrDoors: s.openDoorsFloors
          }
        ].flat()
      )
      .flat();
  }

  isCorridor(): boolean {
    return this.inspection.stairsRooms[0]?.type === PressureSystemType.Corridor;
  }
}
